import React from 'react';
import {
    MetricsRow,
    MetricCard,
    MetricTitle,
    MetricValue,
    ProgressContainer,
    ProgressBar,
    ProgressLabel,
    OverallStats,
} from './AnalyticsTab.styles';
import {
    DashboardCard,
    CardHeader,
    CardTitle,
} from '@components/EmbedDocuments/EmbedDocuments.styles';
import {
    FormControl,
    Select,
    MenuItem
} from '@mui/material';

export default function AnalyticsTab() {
    const completedDocs = [] // mockDocuments.filter(doc => doc.status === 'Completed').length;
    const processingDocs = [] // mockDocuments.filter(doc => doc.status === 'Processing').length;
    const failedDocs = [] // mockDocuments.filter(doc => doc.status === 'Failed').length;
    const totalVectors = 123 // mockDocuments.reduce((sum, doc) => sum + doc.vectors, 0);

    return (
    <>
        <MetricsRow>
            <MetricCard>
                <MetricTitle>Total Documents</MetricTitle>
                <MetricValue>{123}</MetricValue>
                <OverallStats>
                    <div>
                        <span className="stat-value" style={{ color: '#2eb85c' }}>{completedDocs}</span>
                        <span className="stat-label">Completed</span>
                    </div>
                    <div>
                        <span className="stat-value" style={{ color: 'var(--secondary-main)' }}>{processingDocs}</span>
                        <span className="stat-label">Processing</span>
                    </div>
                    <div>
                        <span className="stat-value" style={{ color: '#e53e3e' }}>{failedDocs}</span>
                        <span className="stat-label">Failed</span>
                    </div>
                </OverallStats>
            </MetricCard>

            <MetricCard>
                <MetricTitle>Total Vectors</MetricTitle>
                <MetricValue>{totalVectors}</MetricValue>
                <ProgressContainer>
                    <ProgressBar
                        variant="determinate"
                        value={70}
                    />
                    <ProgressLabel>
                        <span>0</span>
                        <span>Usage: 70% of 5,000</span>
                    </ProgressLabel>
                </ProgressContainer>
            </MetricCard>

            <MetricCard>
                <MetricTitle>Storage Used</MetricTitle>
                <MetricValue>12.6 MB</MetricValue>
                <ProgressContainer>
                    <ProgressBar
                        variant="determinate"
                        value={25}
                    />
                    <ProgressLabel>
                        <span>0</span>
                        <span>Usage: 25% of 50 MB</span>
                    </ProgressLabel>
                </ProgressContainer>
            </MetricCard>

            <MetricCard>
                <MetricTitle>Avg. Processing Time</MetricTitle>
                <MetricValue>1.2 min</MetricValue>
                <div style={{ marginTop: '5px', fontSize: '0.8rem', color: 'rgba(0, 0, 0, 0.5)' }}>
                    Per document
                </div>
            </MetricCard>
        </MetricsRow>

        <DashboardCard>
            <CardHeader>
                <CardTitle>Document Processing History</CardTitle>
                <FormControl size="small" style={{ minWidth: '150px' }}>
                    <Select
                        value="last30"
                        size="small"
                    >
                        <MenuItem value="last7">Last 7 Days</MenuItem>
                        <MenuItem value="last30">Last 30 Days</MenuItem>
                        <MenuItem value="last90">Last 90 Days</MenuItem>
                    </Select>
                </FormControl>
            </CardHeader>

            <div>
                {/* In a real implementation, this would be a chart */}
                <div style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    height: '200px',
                    padding: '20px 0',
                    gap: '15px',
                    justifyContent: 'space-around',
                }}>
                    {[35, 42, 28, 45, 50, 28, 35, 20, 22, 30].map((height, i) => (
                        <div
                            key={i}
                            style={{
                                height: `${height * 2}px`,
                                width: '25px',
                                backgroundColor: 'var(--secondary-light)',
                                borderRadius: '4px 4px 0 0',
                                position: 'relative',
                            }}
                        />
                    ))}
                </div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    padding: '10px 0',
                    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
                    color: 'rgba(0, 0, 0, 0.5)',
                    fontSize: '0.8rem',
                }}>
                    {['May 1', 'May 5', 'May 10', 'May 15', 'May 20', 'May 25', 'May 30', 'Jun 5', 'Jun 10', 'Jun 15'].map((date, i) => (
                        <div key={i}>{date}</div>
                    ))}
                </div>
            </div>
        </DashboardCard>
    </>
    )
}